(function () {
  function money(cents) {
    if (window.theme && theme.Currency && theme.settings) return theme.Currency.formatMoney(cents, theme.settings.moneyFormat);
    return (cents / 100).toFixed(2);
  }
  function cartAddUrl() {
    var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
    return root + 'cart/add.js';
  }

  /* ---------- Bundle & save ---------- */
  function initBundle(el) {
    var form = document.getElementById(el.dataset.formId);
    if (!form || el.dataset.ready) return;
    el.dataset.ready = '1';
    var qtyInput = el.querySelector('[data-pr-bundle-qty]');
    var tiers = Array.prototype.slice.call(el.querySelectorAll('[data-pr-tier]'));
    var variants = [];
    try { variants = JSON.parse(form.querySelector('[data-variant-json]').value); } catch (e) {}

    function currentId() { var s = form.querySelector('[name="id"]'); return s ? Number(s.value) : null; }
    function priceOf(id) {
      for (var i = 0; i < variants.length; i++) if (variants[i].id == id) return variants[i].price;
      return Number(el.dataset.price);
    }
    function select(n) {
      tiers.forEach(function (t) {
        var on = Number(t.dataset.prTier) === n;
        t.classList.toggle('is-active', on);
        t.querySelector('input[type=radio]').checked = on;
      });
      qtyInput.value = n;
      el.dataset.qty = n;
    }
    function reprice() {
      tiers.forEach(function (t) {
        var n = Number(t.dataset.prTier);
        var d = Number(el.dataset['d' + n]) || 0;
        var sels = t.querySelectorAll('[data-pr-variant]');
        var full = 0;
        if (sels.length) { for (var i = 0; i < sels.length; i++) full += priceOf(sels[i].value); }
        else full = priceOf(currentId()) * n;
        var total = Math.round(full * (100 - d) / 100);
        var tot = t.querySelector('[data-pr-total]'); if (tot) tot.innerHTML = money(total);
        var cmp = t.querySelector('[data-pr-compare]'); if (cmp) cmp.innerHTML = money(full);
        var sav = t.querySelector('[data-pr-save]'); if (sav) sav.innerHTML = money(full - total);
      });
    }
    tiers.forEach(function (t) {
      t.querySelector('input[type=radio]').addEventListener('change', function () { select(Number(t.dataset.prTier)); });
      t.querySelectorAll('[data-pr-variant]').forEach(function (s) { s.addEventListener('change', reprice); });
    });

    // Keep the first unit of every tier in sync with the main variant picker
    var section = form.closest('[data-section-type="product"]') || document;
    section.addEventListener('change', function (e) {
      if (!e.target.matches('[data-variant-input]')) return;
      setTimeout(function () {
        var id = currentId();
        tiers.forEach(function (t) { var s = t.querySelector('[data-pr-variant]'); if (s) s.value = id; });
        reprice();
      }, 60);
    });

    // 2+ units with mixed variants -> add as separate lines
    document.addEventListener('submit', function (e) {
      if (e.target !== form) return;
      var n = Number(el.dataset.qty) || 1;
      if (n < 2) return;
      var tier = tiers.filter(function (t) { return Number(t.dataset.prTier) === n; })[0];
      var sels = tier ? tier.querySelectorAll('[data-pr-variant]') : [];
      if (!sels.length) return;
      e.preventDefault();
      e.stopImmediatePropagation();
      var counts = {};
      Array.prototype.forEach.call(sels, function (s) { counts[s.value] = (counts[s.value] || 0) + 1; });
      var items = Object.keys(counts).map(function (id) { return { id: Number(id), quantity: counts[id] }; });
      var btn = form.querySelector('[data-add-to-cart]');
      if (btn) btn.classList.add('btn--loading');
      fetch(cartAddUrl(), {
        method: 'POST',
        credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
        body: JSON.stringify({ items: items })
      })
        .then(function (r) { return r.json(); })
        .then(function (data) {
          if (btn) btn.classList.remove('btn--loading');
          if (data.status) { alert(data.description || data.message); return; }
          if (document.getElementById('CartDrawer')) {
            document.dispatchEvent(new CustomEvent('ajaxProduct:added', { detail: { product: data.items ? data.items[0] : data, addToCartBtn: btn } }));
          } else {
            window.location.href = ((window.Shopify && Shopify.routes && Shopify.routes.root) || '/') + 'cart';
          }
        })
        .catch(function () { if (btn) btn.classList.remove('btn--loading'); form.submit(); });
    }, true);

    reprice();
  }

  /* ---------- Delivery estimate ---------- */
  function initDelivery(el) {
    var out = el.querySelector('[data-pr-delivery-range]');
    if (!out) return;
    var min = Number(el.dataset.min) || 6, max = Number(el.dataset.max) || 8;
    var fmt = { weekday: 'short', day: 'numeric', month: 'short' };
    var loc = document.documentElement.lang || 'en-GB';
    function add(d) { var x = new Date(); x.setDate(x.getDate() + d); return x.toLocaleDateString(loc, fmt); }
    out.textContent = add(min) + ' – ' + add(max);
  }

  /* ---------- Sticky add to cart ---------- */
  function initSticky(el) {
    var section = el.closest('[data-section-type="product"]');
    if (!section) return;
    var mainBtn = section.querySelector('[data-add-to-cart]');
    if (!mainBtn || !('IntersectionObserver' in window)) return;
    document.body.appendChild(el);
    new IntersectionObserver(function (entries) {
      var e = entries[0];
      var show = !e.isIntersecting && e.boundingClientRect.top < 0;
      el.classList.toggle('is-visible', show);
      el.setAttribute('aria-hidden', show ? 'false' : 'true');
      el.querySelector('[data-pr-sticky-btn]').tabIndex = show ? 0 : -1;
    }).observe(mainBtn);
    el.querySelector('[data-pr-sticky-btn]').addEventListener('click', function () { mainBtn.click(); });
    var priceEl = section.querySelector('[data-product-price]');
    var stickyPrice = el.querySelector('[data-pr-sticky-price]');
    if (priceEl && stickyPrice && 'MutationObserver' in window) {
      new MutationObserver(function () { stickyPrice.innerHTML = priceEl.innerHTML; }).observe(priceEl, { childList: true, characterData: true, subtree: true });
    }
  }


  /* ---------- Image viewer (Burberry-style, replaces PhotoSwipe zoom) ---------- */
  var LB = null;
  var ICON_X = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.4" aria-hidden="true"><path d="M4 4l16 16M20 4L4 20"/></svg>';
  var ICON_PLUS = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" aria-hidden="true"><path d="M12 4v16M4 12h16"/></svg>';
  var ICON_MINUS = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" aria-hidden="true"><path d="M4 12h16"/></svg>';
  var ICON_L = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.4" aria-hidden="true"><path d="M15 4l-8 8 8 8"/></svg>';
  var ICON_R = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.4" aria-hidden="true"><path d="M9 4l8 8-8 8"/></svg>';

  function buildLightbox() {
    var el = document.createElement('div');
    el.className = 'pr-lb';
    el.setAttribute('role', 'dialog');
    el.setAttribute('aria-modal', 'true');
    el.setAttribute('aria-label', 'Product images');
    el.innerHTML =
      '<div class="pr-lb__stage">' +
        '<div class="pr-lb__track" data-track></div>' +
        '<span class="pr-lb__count" data-count></span>' +
        '<button type="button" class="pr-lb__close" data-close aria-label="Close">' + ICON_X + '</button>' +
        '<button type="button" class="pr-lb__nav pr-lb__nav--prev" data-prev aria-label="Previous image">' + ICON_L + '</button>' +
        '<button type="button" class="pr-lb__nav pr-lb__nav--next" data-next aria-label="Next image">' + ICON_R + '</button>' +
        '<div class="pr-lb__zoom"><button type="button" data-zin aria-label="Zoom in">' + ICON_PLUS + '</button><button type="button" data-zout aria-label="Zoom out" disabled>' + ICON_MINUS + '</button></div>' +
      '</div>' +
      '<div class="pr-lb__thumbs" data-thumbs></div>';
    document.body.appendChild(el);

    var track = el.querySelector('[data-track]');
    var thumbs = el.querySelector('[data-thumbs]');
    var count = el.querySelector('[data-count]');
    var zin = el.querySelector('[data-zin]');
    var zout = el.querySelector('[data-zout]');
    var st = { index: 0, n: 0, scale: 1, tx: 0, ty: 0, lastFocus: null, scrollT: null };
    var pointers = {};
    var pinch = null, pan = null, lastTap = 0;

    function curImg() { var s = track.children[st.index]; return s ? s.querySelector('img') : null; }
    function clamp(v, m) { return Math.max(-m, Math.min(m, v)); }
    function bounds() {
      var img = curImg(); if (!img) return { x: 0, y: 0 };
      var slide = img.parentNode;
      return {
        x: Math.max(0, (img.offsetWidth * st.scale - slide.clientWidth) / 2),
        y: Math.max(0, (img.offsetHeight * st.scale - slide.clientHeight) / 2)
      };
    }
    function apply(animate) {
      var img = curImg(); if (!img) return;
      var bd = bounds();
      st.tx = clamp(st.tx, bd.x); st.ty = clamp(st.ty, bd.y);
      img.classList.toggle('is-animating', !!animate);
      img.style.transform = st.scale > 1 ? 'translate(' + st.tx + 'px,' + st.ty + 'px) scale(' + st.scale + ')' : '';
      track.classList.toggle('is-zoomed', st.scale > 1);
      zout.disabled = st.scale <= 1;
      zin.disabled = st.scale >= 4;
    }
    function zoomTo(s, cx, cy, animate) {
      var img = curImg(); if (!img) return;
      s = Math.max(1, Math.min(4, s));
      var r = img.parentNode.getBoundingClientRect();
      var px = (cx == null ? r.left + r.width / 2 : cx) - (r.left + r.width / 2);
      var py = (cy == null ? r.top + r.height / 2 : cy) - (r.top + r.height / 2);
      // keep the point under the finger fixed
      var k = s / st.scale;
      st.tx = px - (px - st.tx) * k;
      st.ty = py - (py - st.ty) * k;
      st.scale = s;
      if (s === 1) { st.tx = 0; st.ty = 0; }
      apply(animate);
    }
    function resetZoom() {
      track.querySelectorAll('img').forEach(function (i) { i.style.transform = ''; });
      st.scale = 1; st.tx = 0; st.ty = 0; apply(false);
    }
    function setActive(i) {
      if (i === st.index && track.children[i] && thumbs.children[i].classList.contains('is-active')) return;
      resetZoom();
      st.index = i;
      Array.prototype.forEach.call(thumbs.children, function (t, k) { t.classList.toggle('is-active', k === i); });
      var t = thumbs.children[i];
      if (t) thumbs.scrollTo({ left: t.offsetLeft - (thumbs.clientWidth - t.offsetWidth) / 2, behavior: 'smooth' });
      count.textContent = (i + 1) + ' / ' + st.n;
    }
    function go(i, smooth) {
      i = Math.max(0, Math.min(st.n - 1, i));
      track.scrollTo({ left: i * track.clientWidth, behavior: smooth ? 'smooth' : 'auto' });
      setActive(i);
    }

    track.addEventListener('scroll', function () {
      clearTimeout(st.scrollT);
      st.scrollT = setTimeout(function () {
        var i = Math.round(track.scrollLeft / track.clientWidth);
        if (i !== st.index) setActive(i);
      }, 60);
    }, { passive: true });

    track.addEventListener('pointerdown', function (e) {
      if (e.target.tagName !== 'IMG') return;
      pointers[e.pointerId] = { x: e.clientX, y: e.clientY };
      var ids = Object.keys(pointers);
      if (ids.length === 2) {
        var a = pointers[ids[0]], c = pointers[ids[1]];
        pinch = { d: Math.hypot(a.x - c.x, a.y - c.y), s: st.scale, cx: (a.x + c.x) / 2, cy: (a.y + c.y) / 2 };
        pan = null;
      } else if (st.scale > 1) {
        pan = { x: e.clientX, y: e.clientY, tx: st.tx, ty: st.ty };
        try { e.target.setPointerCapture(e.pointerId); } catch (err) {}
      }
    });
    track.addEventListener('pointermove', function (e) {
      if (!pointers[e.pointerId]) return;
      pointers[e.pointerId] = { x: e.clientX, y: e.clientY };
      var ids = Object.keys(pointers);
      if (pinch && ids.length === 2) {
        var a = pointers[ids[0]], c = pointers[ids[1]];
        var d = Math.hypot(a.x - c.x, a.y - c.y);
        zoomTo(pinch.s * d / pinch.d, pinch.cx, pinch.cy, false);
        e.preventDefault();
      } else if (pan) {
        st.tx = pan.tx + (e.clientX - pan.x);
        st.ty = pan.ty + (e.clientY - pan.y);
        apply(false);
        e.preventDefault();
      }
    });
    function endPointer(e) {
      var p = pointers[e.pointerId];
      delete pointers[e.pointerId];
      if (Object.keys(pointers).length < 2) pinch = null;
      if (!Object.keys(pointers).length) pan = null;
      if (st.scale < 1.05 && st.scale !== 1) zoomTo(1, null, null, true);
      // double tap / click toggles zoom
      if (e.type === 'pointerup' && p && e.target.tagName === 'IMG' && Math.abs(p.x - e.clientX) < 8) {
        var now = Date.now();
        var isTouch = e.pointerType === 'touch';
        if (!isTouch || now - lastTap < 300) {
          if (st.scale > 1) zoomTo(1, null, null, true); else zoomTo(2.5, e.clientX, e.clientY, true);
          lastTap = 0;
        } else lastTap = now;
      }
    }
    track.addEventListener('pointerup', endPointer);
    track.addEventListener('pointercancel', endPointer);
    track.addEventListener('wheel', function (e) {
      if (!e.ctrlKey && st.scale === 1) return;
      e.preventDefault();
      zoomTo(st.scale * (e.deltaY < 0 ? 1.15 : 0.87), e.clientX, e.clientY, false);
    }, { passive: false });

    zin.addEventListener('click', function () { zoomTo(st.scale + 1, null, null, true); });
    zout.addEventListener('click', function () { zoomTo(st.scale - 1 < 1.5 ? 1 : st.scale - 1, null, null, true); });
    el.querySelector('[data-prev]').addEventListener('click', function () { go(st.index - 1, true); });
    el.querySelector('[data-next]').addEventListener('click', function () { go(st.index + 1, true); });
    el.querySelector('[data-close]').addEventListener('click', close);
    thumbs.addEventListener('click', function (e) {
      var t = e.target.closest('[data-i]'); if (t) go(Number(t.dataset.i), true);
    });
    document.addEventListener('keydown', function (e) {
      if (!el.classList.contains('is-open')) return;
      if (e.key === 'Escape') close();
      else if (e.key === 'ArrowLeft') go(st.index - 1, true);
      else if (e.key === 'ArrowRight') go(st.index + 1, true);
    });
    window.addEventListener('resize', function () { if (el.classList.contains('is-open')) go(st.index, false); });

    function open(items, index) {
      st.lastFocus = document.activeElement;
      st.n = items.length;
      track.innerHTML = '';
      thumbs.innerHTML = '';
      items.forEach(function (it, i) {
        var s = document.createElement('div');
        s.className = 'pr-lb__slide';
        var img = document.createElement('img');
        img.alt = it.alt || '';
        img.draggable = false;
        if (Math.abs(i - index) > 1) img.loading = 'lazy';
        img.src = it.src;
        s.appendChild(img);
        track.appendChild(s);
        var t = document.createElement('button');
        t.type = 'button';
        t.className = 'pr-lb__thumb';
        t.dataset.i = i;
        t.setAttribute('aria-label', 'Image ' + (i + 1));
        t.innerHTML = '<img src="' + it.thumb + '" alt="" loading="lazy">';
        thumbs.appendChild(t);
      });
      thumbs.style.display = items.length > 1 ? '' : 'none';
      el.querySelector('[data-prev]').style.display = el.querySelector('[data-next]').style.display = items.length > 1 ? '' : 'none';
      el.classList.add('is-open');
      document.documentElement.style.overflow = 'hidden';
      document.body.style.overflow = 'hidden';
      st.index = -1;
      requestAnimationFrame(function () { go(index, false); el.querySelector('[data-close]').focus({ preventScroll: true }); });
    }
    function close() {
      el.classList.remove('is-open');
      resetZoom();
      document.documentElement.style.overflow = '';
      document.body.style.overflow = '';
      if (st.lastFocus && st.lastFocus.focus) st.lastFocus.focus({ preventScroll: true });
    }
    return { open: open };
  }

  function sizedUrl(src, w) {
    if (!src) return '';
    if (src.indexOf('{width}') > -1) return src.replace('{width}', w);
    return src;
  }
  function galleryItems(root) {
    var slides = Array.prototype.slice.call(root.querySelectorAll('.product-main-slide'));
    var items = [], map = {};
    slides.forEach(function (s) {
      var img = s.querySelector('img.photoswipe__image');
      if (!img || map[s.dataset.index] != null) return;
      map[s.dataset.index] = items.length;
      items.push({
        src: img.getAttribute('data-photoswipe-src') || sizedUrl(img.dataset.src, 1800),
        thumb: sizedUrl(img.dataset.src, 360) || img.currentSrc,
        alt: img.alt
      });
    });
    return { items: items, map: map };
  }

  var down = null;
  document.addEventListener('pointerdown', function (e) { down = { x: e.clientX, y: e.clientY }; }, true);
  document.addEventListener('click', function (e) {
    var t = e.target.closest && e.target.closest('.js-photoswipe__zoom, .product-main-slide .photoswipe__image');
    if (!t) return;
    var root = t.closest('[data-product-images]');
    if (!root || root.dataset.zoom === 'false') return;
    e.preventDefault();
    e.stopImmediatePropagation();
    if (down && Math.hypot(down.x - e.clientX, down.y - e.clientY) > 10) return; // was a swipe
    var g = galleryItems(root);
    if (!g.items.length) return;
    var slide = t.closest('.product-main-slide') || root.querySelector('.product-main-slide.is-selected');
    var idx = slide && g.map[slide.dataset.index] != null ? g.map[slide.dataset.index] : 0;
    if (!LB) LB = buildLightbox();
    LB.open(g.items, idx);
  }, true);

  function init(root) {
    (root || document).querySelectorAll('[data-pr-bundle]').forEach(initBundle);
    (root || document).querySelectorAll('[data-pr-delivery]').forEach(initDelivery);
    (root || document).querySelectorAll('[data-pr-sticky]').forEach(initSticky);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(); });
  else init();
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
